import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {BorderLabels} from '../../BorderLabels';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

/**
 * @description base class including structure border modifications logic
 */
export abstract class StructureBorderBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.STRUCTURE].BORDER_FORM;
  }

  public getLabels(): BorderLabels | undefined {
    return undefined;
  }
}
